import { debounce } from 'lodash'

import { DateFields, Services } from '@sigma-frontend-libs/commons'
import { Macro } from '@sigma-legacy-libs/cache'
import { isUUID } from '@sigmasms/commons'
import { OrderDirections } from '@sigmasms/shared-types'

import { globalErrorHandler, macroCacheOptions, permissionPresets, request } from '@/utils'

import render from './render'

const Cache = new Macro(macroCacheOptions)

const cachedFind = Cache.wrapWithCache(async (key, query) => {
  return await request.find(Services.contacts, undefined, query)
})

export default {
  name: 'ContactsTag',

  props: {
    label: {
      type: String,
      default: undefined
    },

    ListId: {
      type: String,
      default: undefined
    },

    cancel: {
      type: Function,
      default: undefined
    }
  },

  data() {
    return {
      loading: false,
      items: [],
      total: 0
    }
  },

  computed: {
    canGetContacts() {
      return this.checkPermissions(`advanced.${Services.contacts}.get`, permissionPresets.meUp)
    },

    tooltip() {
      if (isUUID(this.ListId)) {
        if (this.loading) {
          return this.getTranslate(`${Services.contacts}.tooltips.loading`)
        } else if (this.items.length) {
          if (this.total > 10) {
            this.items.push(this.getTranslate(`${Services.contacts}.tooltips.total`, { total: this.total }))
          }

          return this.items.join('\n')
        }

        return this.getTranslate(`${Services.contacts}.tooltips.noData`)
      }
    },

    $_props() {
      return {
        as: 'select',
        label: this.label,
        tooltip: this.tooltip,
        cancelable: true,
        cancel: () => {
          return this.cancel()
        }
      }
    }
  },

  methods: {
    async _getContacts() {
      try {
        if (this.canGetContacts) {
          if (isUUID(this.ListId)) {
            this.loading = true
            this.items = []
            const data = await cachedFind(`${Services.contacts}:get:${this.ListId}`, {
              ListId: this.ListId,
              $offset: 0,
              $limit: 10,
              $order: [ [ DateFields.createdAt, OrderDirections.DESC ] ],
              isActive: true
            })
            if (data?.data && data?.data?.length) {
              for (const { phone } of data.data) {
                if (phone) {
                  this.items.push(phone)
                }
              }
              this.total = data?.total
            }
          }
        }
      } catch (error) {
        globalErrorHandler(error)
      } finally {
        this.loading = false
      }
    },

    getContacts: debounce(
      async function() {
        await this._getContacts()
      },
      100,
      {
        leading: true,
        trailing: true
      }
    )
  },

  render
}
